// extracted by mini-css-extract-plugin
export default {"teddyWrapper":"Auction_teddyWrapper__+kne0","teddyContentCol":"Auction_teddyContentCol__dASjq","auctionActivityCol":"Auction_auctionActivityCol__KuMUP"};